// extracted by mini-css-extract-plugin
export default {"footer":"DigitalCheckout_footer__ABIva"};